import { keyframes, styled } from '@mui/material';
import { Box, Typography } from '@mui/material';

const breathe = keyframes`
  0% { transform: scale(0.95); opacity: 0.8; }
  50% { transform: scale(1.05); opacity: 1; }
  100% { transform: scale(0.95); opacity: 0.8; }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const BouncingText = styled(Typography)({
  animation: `${breathe} 1.5s ease-in-out infinite`,
});

const GradientSpinner = styled('div')(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: '50%',
  position: 'relative',
  margin: 16,
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    border: `3px solid ${theme.palette.primary.light}`,
    borderTopColor: theme.palette.primary.main,
    animation: `${rotate} 1.2s cubic-bezier(0.4, 0, 0.2, 1) infinite`,
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 6,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.action.hover}`,
  }
}));

export const Loading = () => {
  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1300,
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        transform: 'translateY(-20%)'
      }}>
        <GradientSpinner />
        <BouncingText 
          variant="h6" 
          sx={{ 
            mt: 2, 
            color: 'text.primary',
            fontWeight: 500,
            letterSpacing: '0.5px'
          }}
        >
          Cargando
        </BouncingText>
      </Box>
    </Box>
  );
};

export default Loading;
